import gql from 'graphql-tag';

export const hideDesignerProfileBoard = gql`
  mutation hideDesignerProfileBoard(
    $boardId: ID!
  ) {
    hideDesignerProfileBoard(
      boardId: $boardId
    ) {
      isHidden
      id
    }
  }
`;

export const unhideDesignerProfileBoard = gql`
  mutation unhideDesignerProfileBoard(
    $boardId: ID!
  ) {
    unhideDesignerProfileBoard(
      boardId: $boardId
    ) {
      isHidden
      id
    }
  }
`;
